export default "__VITE_ASSET__BOs8WpdX__"